import { Theme } from "@mui/material/styles";

export const animationSuccessStyles = (theme: Theme) => ({
  animationBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    mt: 1,
    [theme.breakpoints.down("md")]: {
      mt: 0,
    },
  },
  player: { width: "50%", height: "auto" },
});
